<div class="history-container">
    <div class="tabs-container">
        <button (click)="currentTab = tabConfiguration" class="tab"
            [ngClass]="{'active': currentTab == tabConfiguration}">Configurations<span
                class="tab-pill">{{nodeConfigurationsCount}}</span></button>
        <button (click)="currentTab = tabActions" class="tab" [ngClass]="{'active': currentTab == tabActions}">Node
            actions<span class="tab-pill">{{nodeActionsCount}}</span></button>
        <button (click)="currentTab = tabThreatments" class="tab"
            [ngClass]="{'active': currentTab == tabThreatments}">Threat managements<span
                class="tab-pill">{{nodeThreatManagementsCount}}</span></button>
    </div>
    <div [hidden]="currentTab !== tabConfiguration" class="history-tab-content">
        <app-paginator #configurationsPaginator (pageChange)="loadNodeConfiguration()"></app-paginator>
        <div [ngClass]="{'hidden': !nodeSelectedConfigurationJson}" class="history-data-container">
            <div class="p-2">
                <div class="block mb-2">Configuration date: <span>{{nodeSelectedConfigurationTimestamp | date:
                        'dd-MM-yyyy hh:mm:ss'}}</span></div>
                <pre>{{nodeSelectedConfigurationJson | json}}</pre>
            </div>
        </div>
    </div>
    <div [hidden]="currentTab !== tabActions" class="history-tab-content">
        <app-paginator #actionsPaginator (pageChange)="loadNodeAction()"></app-paginator>
        <div [ngClass]="{'hidden': !nodeSelectedAction}" class="history-data-container">
            <div class="history-data-titles">
                <span>Action</span>
                <span>Timestamp</span>
                <span>User</span>
                <span>Data</span>
            </div>
            <div class="history-data-values">
                <span>{{nodeSelectedAction?.action}}</span>
                <span>{{nodeSelectedAction?.timestamp | date: 'dd-MM-yyyy hh:mm:ss'}}</span>
                <span>{{nodeSelectedAction?.user?.userName}} {{nodeSelectedAction?.user?.name}}
                    {{nodeSelectedAction?.user?.surname}}</span>
                <span>{{nodeSelectedAction?.data}}</span>
            </div>
        </div>
    </div>
    <div [hidden]="currentTab !== tabThreatments" class="history-tab-content">
        <app-paginator #threatmentsPaginator (pageChange)="loadNodeThreatment()"></app-paginator>
        <div [ngClass]="{'hidden': !nodeSelectedThreatManagement}" class="history-data-container">
            <div class="history-data-titles">
                <span>Threat type</span>
                <span>Alert ID</span>
                <span>Alert date</span>
                <span>Status</span>
                <span>Managed by</span>
                <span>Node ID</span>
                <span>Node Address</span>
            </div>
            <div class="history-data-values">
                <span>{{nodeSelectedThreatManagement?.threatType}}</span>
                <span>{{nodeSelectedThreatManagement?.alert?.id}}</span>
                <span>{{nodeSelectedThreatManagement?.alert?.date | date: 'dd-MM-yyyy hh:mm:ss'}}</span>
                <span
                    *ngIf="nodeSelectedThreatManagement && nodeSelectedThreatManagement?.alert">{{utils.getStatus(nodeSelectedThreatManagement.alert)}}</span>
                <span
                    *ngIf="nodeSelectedThreatManagement && nodeSelectedThreatManagement?.alert">{{getUsersWhoManagedAlert(nodeSelectedThreatManagement.alert)}}</span>
                <span>{{nodeSelectedThreatManagement?.alert?.node?.id}}</span>
                <span>{{nodeSelectedThreatManagement?.alert?.node?.address}}</span>
            </div>
        </div>
    </div>
    <span class="history-blockchain-banner">Secured with <span>Blockchain</span> technology</span>
</div>